
import css_icon from './css_icon.png'
import git_icon from './git_icon.png'
import html_icon from './html_icon.png'
import responsive_icon from './responsive_icon.png'; 
import javascript_icon from './javascript_icon.png'
import react_icon from './react_icon.png'
import github_icon from './github_icon.png'
import typerwriter_icon from './typewriter_icon.png'
import gemini_icon from './gemini_icon.png'
import youtube_icon from './youtube_icon.png'
import rpsgame_icon from './rpsgame_icon.png'
import socialmedia_icon from './socialmedia_icon.png'
import youtube2_icon from './youtube2_icon.png'
import amazon3_icon from './amazon3_icon.png'
import movies_icon from './movies_icon.png'
import ragul3_icon from './ragul3_icon.png'
import ragulnew2_icon from './ragulnew2_icon.png'








export const assets = {
  
  css_icon,
  git_icon,
  html_icon,
  javascript_icon,
  responsive_icon,
  react_icon,
  github_icon,
  typerwriter_icon,
  gemini_icon,
  youtube_icon,
  rpsgame_icon,
  socialmedia_icon,
  youtube2_icon,
  amazon3_icon,
  movies_icon,
  ragul3_icon,
  ragulnew2_icon
  
}